var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{directives:[{name:"prevent",rawName:"v-prevent",value:(2000),expression:"2000"}],class:{ codeGeting: _vm.isGeting },staticStyle:{"background":"#fff","color":"#00acbe","border":"none","padding":"0"},attrs:{"disabled":_vm.disable},on:{"click":_vm.getVerifyCode}},[_vm._v(_vm._s(_vm.getCode)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }